<template>
  <basic-container>
    <div class="entry-notice-page">
      <div class="entry-notice-panel">
        <div class="entry-notice-summary">
          <div class="entry-notice-summary__item">
            <span class="entry-notice-summary__label">状态</span>
            <el-tag size="small" :type="statusType">{{ statusText }}</el-tag>
          </div>
          <div class="entry-notice-summary__item">
            <span class="entry-notice-summary__label">版本</span>
            <strong>{{ noticeForm.standardVersion || "-" }}</strong>
          </div>
          <div class="entry-notice-summary__item">
            <span class="entry-notice-summary__label">生效时间</span>
            <strong>{{ noticeForm.effectiveTime || "-" }}</strong>
          </div>
          <div class="entry-notice-summary__item">
            <span class="entry-notice-summary__label">更新时间</span>
            <strong>{{ noticeForm.updateTime || noticeForm.createTime || "-" }}</strong>
          </div>
        </div>

        <el-form
          ref="noticeForm"
          :model="noticeForm"
          :rules="rules"
          label-width="100px"
          class="entry-notice-form"
          v-loading="loading"
        >
          <div class="entry-notice-section">
            <span class="entry-notice-section__bar"></span>
            <span>基础信息</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="须知标题" prop="standardTitle">
                <el-input v-model="noticeForm.standardTitle" maxlength="100" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="版本" prop="standardVersion">
                <el-input v-model="noticeForm.standardVersion" maxlength="50" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生效时间">
                <el-date-picker
                  v-model="noticeForm.effectiveTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="启用状态">
                <el-switch
                  v-model="noticeForm.enableFlag"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="启用"
                  inactive-text="停用"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="须知内容" prop="standardContent">
                <div class="standard-rich-editor">
                  <AvueUeditor
                    v-model="noticeForm.standardContent"
                    :options="ueditorOptions"
                  />
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input v-model="noticeForm.remark" type="textarea" :rows="3" maxlength="500" />
              </el-form-item>
            </el-col>
          </el-row>
          <div class="entry-notice-form__footer">
            <el-button icon="el-icon-refresh" @click="loadNotice">刷新</el-button>
            <el-button type="primary" icon="el-icon-check" :loading="saving" @click="saveNotice">保存</el-button>
            <el-button type="primary" plain icon="el-icon-document" @click="goReadRecord">
              阅读记录
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
  </basic-container>
</template>

<script>
import { getList, add, update } from "./api";
import AvueUeditor from "avue-plugin-ueditor/packages/ueditor";
import request from "@/router/axios";

const emptyNotice = () => ({
  id: null,
  standardTitle: "入厂须知",
  standardVersion: "",
  standardContent: "",
  effectiveTime: "",
  enableFlag: 1,
  remark: "",
});

export default {
  name: "DriverEntryNotice",
  components: {
    AvueUeditor,
  },
  data() {
    return {
      loading: false,
      saving: false,
      noticeForm: emptyNotice(),
      ueditorOptions: {
        customConfig: {
          zIndex: 200,
        },
      },
      rules: {
        standardTitle: [{ required: true, message: "请输入须知标题", trigger: "blur" }],
        standardVersion: [{ required: true, message: "请输入版本", trigger: "blur" }],
        standardContent: [{ required: true, message: "请输入须知内容", trigger: "blur" }],
      },
    };
  },
  created() {
    if (!this.$axios) {
      this.$axios = request;
    }
    this.loadNotice();
  },
  computed: {
    statusText() {
      return this.noticeForm.enableFlag === 1 ? "启用" : "停用";
    },
    statusType() {
      return this.noticeForm.enableFlag === 1 ? "success" : "info";
    },
  },
  methods: {
    loadNotice() {
      this.loading = true;
      getList({ page: 1, size: 1 })
        .then((res) => {
          const data = res.data.data || {};
          const record = data.records && data.records.length ? data.records[0] : null;
          this.noticeForm = record ? { ...emptyNotice(), ...record } : emptyNotice();
          this.noticeForm.standardContent = this.normalizeStandardContent(this.noticeForm.standardContent);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveNotice() {
      this.noticeForm.standardContent = this.normalizeStandardContent(this.noticeForm.standardContent);
      this.$refs.noticeForm.validate((valid) => {
        if (!valid) return;
        this.saving = true;
        const request = this.noticeForm.id ? update : add;
        request(this.noticeForm)
          .then(() => {
            this.$message.success("保存成功");
            this.loadNotice();
          })
          .finally(() => {
            this.saving = false;
          });
      });
    },
    normalizeStandardContent(content) {
      if (!content) return "";
      const value = String(content).trim();
      if (!value) return "";
      return this.hasHtmlTag(value) ? value : this.plainTextToHtml(value);
    },
    hasHtmlTag(value) {
      return /<\/?[a-z][\s\S]*>/i.test(value);
    },
    plainTextToHtml(text) {
      if (!text) return "";
      return String(text)
        .replace(/\r\n/g, "\n")
        .replace(/\r/g, "\n")
        .split(/\n{2,}/)
        .map((paragraph) => {
          const lines = paragraph.split("\n").map((line) => this.escapeHtml(line));
          return `<p>${lines.join("<br>") || "<br>"}</p>`;
        })
        .join("");
    },
    escapeHtml(text) {
      return String(text)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    goReadRecord() {
      this.$router.push("/basic-info/driver-entry-standard/read-record");
    },
  },
};
</script>

<style scoped lang="scss">
.entry-notice-page {
  padding: 16px;
}

.entry-notice-panel {
  padding: 18px;
  border-radius: 4px;
  background: #fff;
}

.entry-notice-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0;
  border: 1px solid #edf1f7;
  border-radius: 4px;
  background: #fbfcff;
  margin-bottom: 18px;
}

.entry-notice-summary__item {
  min-height: 58px;
  padding: 10px 16px;
  border-right: 1px solid #edf1f7;

  &:last-child {
    border-right: none;
  }

  strong {
    display: block;
    margin-top: 6px;
    color: #17233d;
    font-size: 14px;
    font-weight: 500;
    word-break: break-all;
  }
}

.entry-notice-summary__label {
  display: block;
  color: #7a8499;
  font-size: 12px;
}

.entry-notice-form {
  max-width: 1080px;
}

.entry-notice-section {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0 16px;
  color: #17233d;
  font-weight: 600;
}

.entry-notice-section__bar {
  width: 3px;
  height: 16px;
  border-radius: 2px;
  background: #2d8cf0;
}

.entry-notice-form__footer {
  padding-left: 100px;
  padding-top: 4px;
}

.standard-rich-editor {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;

  ::v-deep .w-e-text-container {
    min-height: 320px;
  }
}

@media (max-width: 1200px) {
  .entry-notice-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .entry-notice-summary__item:nth-child(2) {
    border-right: none;
  }

  .entry-notice-summary__item:nth-child(-n + 2) {
    border-bottom: 1px solid #edf1f7;
  }
}
</style>
